(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1141],{

/***/ 21141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ InitBooking_InitBooking; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./src/components/models/booking/InitBooking/InitBooking.module.scss
var InitBooking_module = __webpack_require__(52619);
var InitBooking_module_default = /*#__PURE__*/__webpack_require__.n(InitBooking_module);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./src/app/context.ts
var context = __webpack_require__(27802);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/components/models/booking/InitBooking/TravelDateSelector/TravelDateSelector.module.scss
var TravelDateSelector_module = __webpack_require__(39202);
var TravelDateSelector_module_default = /*#__PURE__*/__webpack_require__.n(TravelDateSelector_module);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
// EXTERNAL MODULE: ./src/components/elements/inputs/CustomSelect/CustomSelect.module.scss
var CustomSelect_module = __webpack_require__(17906);
var CustomSelect_module_default = /*#__PURE__*/__webpack_require__.n(CustomSelect_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 11 modules
var Form = __webpack_require__(28431);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(42473);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var lib_esm = __webpack_require__(47150);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Nav.js
var Nav = __webpack_require__(25115);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js
var useEventCallback = __webpack_require__(78146);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/NavItem.js
var NavItem = __webpack_require__(73716);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/SelectableContext.js
var SelectableContext = __webpack_require__(87126);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ListGroupItem.js







const ListGroupItem = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  active,
  disabled,
  eventKey,
  className,
  variant,
  action,
  as,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'list-group-item');
  const [navItemProps, meta] = (0,NavItem/* useNavItem */.v)({
    key: (0,SelectableContext/* makeEventKey */.h)(eventKey, props.href),
    active,
    ...props
  });
  const handleClick = (0,useEventCallback/* default */.Z)(event => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    navItemProps.onClick(event);
  });

  if (disabled && props.tabIndex === undefined) {
    props.tabIndex = -1;
    props['aria-disabled'] = true;
  } // eslint-disable-next-line no-nested-ternary


  const Component = as || (action ? props.href ? 'a' : 'button' : 'div');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    ...navItemProps,
    onClick: handleClick,
    className: classnames_default()(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && `${bsPrefix}-${variant}`, action && `${bsPrefix}-action`)
  });
});
ListGroupItem.displayName = 'ListGroupItem';
/* harmony default export */ var esm_ListGroupItem = (ListGroupItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ListGroup.js








const ListGroup = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    className,
    bsPrefix: initialBsPrefix,
    variant,
    horizontal,
    numbered,
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as = 'div',
    ...controlledProps
  } = (0,lib_esm/* useUncontrolled */.Ch)(props, {
    activeKey: 'onSelect'
  });
  const bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(initialBsPrefix, 'list-group');
  let horizontalVariant;

  if (horizontal) {
    horizontalVariant = horizontal === true ? 'horizontal' : `horizontal-${horizontal}`;
  }

   false ? 0 : void 0;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Nav/* default */.Z, {
    ref: ref,
    ...controlledProps,
    as: as,
    className: classnames_default()(className, bsPrefix, variant && `${bsPrefix}-${variant}`, horizontalVariant && `${bsPrefix}-${horizontalVariant}`, numbered && `${bsPrefix}-numbered`)
  });
});
ListGroup.displayName = 'ListGroup';
/* harmony default export */ var esm_ListGroup = (Object.assign(ListGroup, {
  Item: esm_ListGroupItem
}));
;// CONCATENATED MODULE: ./src/hooks/useOutside.tsx

function useOutside(ref, callback) {
    (0,react.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(event) {
            // @ts-ignore
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        callback,
        ref
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/useEscapeKey.tsx

function useEscapeKey(callback) {
    (0,react.useEffect)(function() {
        var handleEscapePressed = function handleEscapePressed(event) {
            if (event.keyCode === 27) {
                callback();
            }
        };
        // Bind the event listener
        document.addEventListener("keydown", handleEscapePressed);
        return function() {
            // Unbind the event listener on clean up
            document.removeEventListener("keydown", handleEscapePressed);
        };
    }, [
        callback
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/useArrowNavigation.tsx

var keyCodes = {
    37: "left",
    38: "up",
    39: "right",
    40: "down"
};
function useArrowNavigation(callback) {
    (0,react.useEffect)(function() {
        var handleKeyPressed = function handleKeyPressed(event) {
            if (keyCodes[event.keyCode] !== undefined) {
                callback(event, keyCodes[event.keyCode]);
            }
        };
        // Bind the event listener
        document.addEventListener("keydown", handleKeyPressed);
        return function() {
            // Unbind the event listener on clean up
            document.removeEventListener("keydown", handleKeyPressed);
        };
    }, [
        callback
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/useEnterKey.tsx

function useEnterKey(callback) {
    (0,react.useEffect)(function() {
        var handleKeyDown = /**
     * Alert if clicked on outside of element
     */ function handleKeyDown(event) {
            if (event.keyCode === 13) {
                callback();
            }
        };
        // Bind the event listener
        document.addEventListener("keydown", handleKeyDown);
        return function() {
            // Unbind the event listener on clean up
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        callback
    ]);
}

;// CONCATENATED MODULE: ./src/components/elements/inputs/CustomSelect/CustomSelect.tsx









var CustomSelect = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, placeholder = param.placeholder, options = param.options, initialSelected = param.selected, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, renderOption = param.renderOption, renderInputValue = param.renderInputValue, onChange = param.onChange, _preventCloseOnClickOutside = param.preventCloseOnClickOutside, preventCloseOnClickOutside = _preventCloseOnClickOutside === void 0 ? false : _preventCloseOnClickOutside;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(initialSelected), selected = ref1[0], setSelected = ref1[1];
    var ref2 = (0,react.useState)(undefined), focused = ref2[0], setFocused = ref2[1];
    var singleOption = options.length <= 1;
    (0,react.useEffect)(function() {
        setSelected(initialSelected);
    }, [
        initialSelected
    ]);
    // state handlers
    var getInputDisplayValue = function() {
        return selected ? renderInputValue(selected) : placeholder;
    };
    var toggleOpen = function() {
        if (open) {
            handleClose();
        } else {
            handleOpen();
        }
    };
    var handleSelect = function(option) {
        setSelected(option);
        onChange(option);
        handleClose();
    };
    var handleOpen = function() {
        if (!singleOption) {
            setOpen(true);
        }
    };
    var handleClose = function() {
        if (open) {
            setOpen(false);
            setFocused(undefined);
        }
    };
    var isSelected = function(option) {
        return lodash_default().isEqual(JSON.stringify(option), JSON.stringify(selected));
    };
    // a11y hooks
    var wrapperRef = (0,react.useRef)(null);
    useOutside(wrapperRef, function() {
        if (!preventCloseOnClickOutside) {
            handleClose();
        }
    });
    useEscapeKey(function() {
        handleClose();
    });
    useEnterKey(function() {
        if (focused) {
            handleSelect(focused);
        }
    });
    useArrowNavigation(function(event, direction) {
        if (open) {
            event.preventDefault();
            var index = options.findIndex(function(option) {
                return option === focused;
            });
            switch(direction){
                case "left":
                case "up":
                    if (index > 0) {
                        setFocused(options[index - 1]);
                    }
                    if (index == -1) {
                        setFocused(options.slice(-1).pop());
                    }
                    break;
                case "right":
                case "down":
                    if (index + 1 < options.length) {
                        setFocused(options[index + 1]);
                    }
                    break;
            }
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
            className: "form-group ".concat((CustomSelect_module_default()).root, " ").concat((CustomSelect_module_default())[variant]),
            ref: wrapperRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((CustomSelect_module_default()).input, " ").concat(open && (CustomSelect_module_default()).active, " ").concat(disabled === true ? (CustomSelect_module_default()).disabled : "", " ").concat(singleOption ? (CustomSelect_module_default()).noOptions : ""),
                    onClick: toggleOpen,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CustomSelect_module_default()).label,
                        children: getInputDisplayValue()
                    })
                }),
                open && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ListGroup, {
                    className: (CustomSelect_module_default()).dropdown,
                    onMouseEnter: function() {
                        return setFocused(null);
                    },
                    children: options.map(function(option, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ListGroup.Item, {
                            className: "".concat((CustomSelect_module_default()).option, " ").concat(option.disabled ? (CustomSelect_module_default()).disabled : "", " ").concat(isSelected(option) ? (CustomSelect_module_default()).selected : "", " ").concat(option === focused ? (CustomSelect_module_default()).focus : ""),
                            disabled: option.disabled,
                            onClick: function() {
                                return handleSelect(option);
                            },
                            children: renderOption(option)
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var CustomSelect_CustomSelect = (CustomSelect);

;// CONCATENATED MODULE: ./src/components/elements/inputs/CustomSelect/index.ts


// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(98324);
// EXTERNAL MODULE: ./src/features/booking/index.ts + 1 modules
var features_booking = __webpack_require__(70894);
// EXTERNAL MODULE: ./src/lib/booking/LocalBooking.ts + 1 modules
var LocalBooking = __webpack_require__(64401);
// EXTERNAL MODULE: ./src/app/providers/AppConfigProvider.tsx
var AppConfigProvider = __webpack_require__(43953);
// EXTERNAL MODULE: ./src/components/models/booking/BookingWizard/components/FullyBookedOverlay/index.ts + 1 modules
var FullyBookedOverlay = __webpack_require__(18316);
;// CONCATENATED MODULE: ./src/components/models/booking/InitBooking/TravelDateSelector/TravelDateSelector.tsx














var TravelDateSelector = function(param) {
    var _colorTheme = param.colorTheme, colorTheme = _colorTheme === void 0 ? "light" : _colorTheme;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var appConfig = (0,react.useContext)(AppConfigProvider/* AppConfigContext */.J);
    var travelId = (0,react.useContext)(context/* TravelIdContext */.Hu);
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var bookings = (0,hooks/* useAppSelector */.C)(features_booking/* selectBookings */.wY);
    var booking = (0,features_booking/* getStateBooking */.U_)(bookings, travelId);
    var manager = new LocalBooking/* default */.Z(booking);
    var onChange = function(date) {
        dispatch((0,features_booking/* setTravelDate */.DY)({
            travelId: travelId,
            date: date
        }));
    };
    var availableDates = manager.getAvailableTravelDates().map(function(date) {
        // disable dates that are fully booked
        if (date.availabilityStatus && date.availabilityStatus.status === "CLOSED") {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, date), {
                disabled: true
            });
        }
        return date;
    });
    var selectedDate = booking && booking.travelDate && (0,helpers/* isFutureDate */.YI)(booking.travelDate.startDate) ? booking.travelDate : undefined;
    var getTravelDateLabel = function(date) {
        if (date.startDate == date.endDate) {
            return (0,helpers/* toUiDate */.$I)(date.startDate);
        } else {
            return "".concat((0,helpers/* toUiDate */.$I)(date.startDate), " - ").concat((0,helpers/* toUiDate */.$I)(date.endDate));
        }
    };
    var getDaysCountLabel = function(date) {
        if (appConfig.booking.displayDurationDays) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                style: {
                    fontSize: "0.7rem"
                },
                children: [
                    "(",
                    t("days", {
                        count: (0,helpers/* dateRangeDays */.JN)(date.startDate, date.endDate)
                    }),
                    ")"
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: booking && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect_CustomSelect, {
            variant: colorTheme === "light" ? "default" : "whiteOutline",
            placeholder: t(availableDates.length > 0 ? "booking.travelDate" : "booking.noAvailableTravelDate"),
            options: availableDates,
            selected: selectedDate,
            disabled: !booking.pricingTravel || !availableDates.length,
            onChange: onChange,
            renderOption: function(date) {
                // @ts-ignore
                var isDisabled = date.disabled;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TravelDateSelector_module_default()).option,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FullyBookedOverlay/* default */.Z, {
                            contingent: isDisabled ? 0 : 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TravelDateSelector_module_default()).date,
                            children: [
                                "".concat(getTravelDateLabel(date)),
                                " ",
                                getDaysCountLabel(date)
                            ]
                        }),
                        date.includesExtension && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TravelDateSelector_module_default()).extension,
                            children: [
                                t("booking.with") + " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (TravelDateSelector_module_default()).label,
                                    children: date.extension.label
                                })
                            ]
                        })
                    ]
                });
            },
            renderInputValue: function(date) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        getTravelDateLabel(date),
                        " ",
                        getDaysCountLabel(date)
                    ]
                });
            }
        })
    });
};
/* harmony default export */ var TravelDateSelector_TravelDateSelector = (TravelDateSelector);

;// CONCATENATED MODULE: ./src/components/models/booking/InitBooking/TravelDateSelector/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/models/booking/InitBooking/TravellerSelector/TravellerSelector.module.scss
var TravellerSelector_module = __webpack_require__(93632);
var TravellerSelector_module_default = /*#__PURE__*/__webpack_require__.n(TravellerSelector_module);
// EXTERNAL MODULE: ./src/components/elements/inputs/SelectWidget/SelectWidget.module.scss
var SelectWidget_module = __webpack_require__(61430);
var SelectWidget_module_default = /*#__PURE__*/__webpack_require__.n(SelectWidget_module);
;// CONCATENATED MODULE: ./src/components/elements/inputs/SelectWidget/SelectWidget.tsx






var SelectWidget = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, openOverride = param.open, placeholder = param.placeholder, inputValue = param.inputValue, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, renderWidget = param.renderWidget, _preventCloseOnClickOutside = param.preventCloseOnClickOutside, preventCloseOnClickOutside = _preventCloseOnClickOutside === void 0 ? false : _preventCloseOnClickOutside;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    (0,react.useEffect)(function() {
        setOpen(openOverride);
    }, [
        openOverride
    ]);
    // state handlers
    var getInputDisplayValue = function() {
        return inputValue ? inputValue : placeholder;
    };
    var toggleOpen = function() {
        if (open) {
            handleClose();
        } else {
            handleOpen();
        }
    };
    var handleOpen = function() {
        setOpen(true);
    };
    var handleClose = function() {
        if (open) {
            setOpen(false);
        }
    };
    // a11y hooks
    var wrapperRef = (0,react.useRef)(null);
    useOutside(wrapperRef, function() {
        if (!preventCloseOnClickOutside) {
            handleClose();
        }
    });
    useEscapeKey(function() {
        handleClose();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
            className: "form-group ".concat((SelectWidget_module_default()).root, " ").concat((SelectWidget_module_default())[variant]),
            ref: wrapperRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((SelectWidget_module_default()).input, " ").concat(open && (SelectWidget_module_default()).active, " ").concat(disabled && (SelectWidget_module_default()).disabled),
                    onClick: toggleOpen,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SelectWidget_module_default()).label,
                        children: getInputDisplayValue()
                    })
                }),
                open && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SelectWidget_module_default()).dropdown,
                    children: renderWidget()
                })
            ]
        })
    });
};
/* harmony default export */ var SelectWidget_SelectWidget = (SelectWidget);

;// CONCATENATED MODULE: ./src/components/elements/inputs/SelectWidget/index.ts


// EXTERNAL MODULE: ./src/components/elements/inputs/NumberToggle/index.ts + 1 modules
var NumberToggle = __webpack_require__(32699);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TextField/TextField.js + 38 modules
var TextField = __webpack_require__(26804);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/DatePicker/DatePicker.js + 96 modules
var DatePicker = __webpack_require__(4641);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/AdapterDateFns/index.js + 96 modules
var AdapterDateFns = __webpack_require__(61765);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js + 2 modules
var LocalizationProvider = __webpack_require__(52359);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/de/index.js + 5 modules
var de = __webpack_require__(70879);
;// CONCATENATED MODULE: ./src/components/elements/pickers/BirthdayPicker/BirthdayPicker.tsx










var BirthdayPicker = function(param) {
    var value = param.value, minDate = param.minDate, maxDate = param.maxDate, onChange = param.onChange, _width = param.width, width = _width === void 0 ? "auto" : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: style_default().dynamic([
            [
                "55b2efc462ca904c",
                [
                    width
                ]
            ]
        ]) + " " + "birthday-picker",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                dateAdapter: AdapterDateFns/* AdapterDateFns */.H,
                adapterLocale: de/* default */.Z,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker/* DatePicker */.M, {
                    mask: "__.__.____",
                    openTo: "year",
                    views: [
                        "year",
                        "month",
                        "day"
                    ],
                    label: "",
                    value: value,
                    onChange: onChange,
                    inputFormat: "dd.MM.yyyy",
                    renderInput: function(params) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                            helperText: null
                        }));
                    },
                    minDate: minDate ? minDate : undefined,
                    maxDate: maxDate ? maxDate : new Date()
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "55b2efc462ca904c",
                dynamic: [
                    width
                ],
                children: ".birthday-picker{width:".concat(width, "}.birthday-picker input{padding:5px!important}.birthday-picker .MuiIconButton-root{padding:0;margin-top:2px}.birthday-picker fieldset{top:-10px}.birthday-picker legend{width:0}")
            })
        ]
    });
};
/* harmony default export */ var BirthdayPicker_BirthdayPicker = (BirthdayPicker);

;// CONCATENATED MODULE: ./src/components/elements/pickers/BirthdayPicker/index.ts


;// CONCATENATED MODULE: ./src/components/models/booking/InitBooking/TravellerSelector/TravellerSelector.tsx
















var dateIsInInRange = function(proofDate, startDate, endDate) {
    // @ts-ignore
    if (!(0,_instanceof/* default */.Z)(proofDate, Date) || isNaN(proofDate)) {
        return false;
    }
    if (proofDate.getTime() < startDate.getTime()) {
        return false;
    }
    if (proofDate.getTime() > endDate.getTime()) {
        return false;
    }
    return true;
};
var getChildrenAgeRange = function(ageGroups) {
    var minAge = 1000;
    var maxAge = 0;
    ageGroups.filter(function(ageGroup) {
        return ageGroup.type === "MINOR";
    }).forEach(function(ageGroup) {
        if (ageGroup.minAge < minAge) {
            minAge = ageGroup.minAge;
        }
        if (ageGroup.maxAge > maxAge) {
            maxAge = ageGroup.maxAge;
        }
    });
    return {
        min: minAge,
        max: maxAge
    };
};
var TravellerSelector = function(param) {
    var ageGroupSettings = param.ageGroupSettings, _colorTheme = param.colorTheme, colorTheme = _colorTheme === void 0 ? "light" : _colorTheme;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var travelId = (0,react.useContext)(context/* TravelIdContext */.Hu);
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var bookings = (0,hooks/* useAppSelector */.C)(features_booking/* selectBookings */.wY);
    var booking = (0,features_booking/* getStateBooking */.U_)(bookings, travelId);
    var manager = new LocalBooking/* default */.Z(booking);
    var childrenAllowed = manager.childrenAllowed();
    var babiesAllowed = manager.babiesAllowed();
    var ref = (0,react.useState)(null), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(manager.getTravellerSelectionLabel(t)), inputValue = ref1[0], setInputValue = ref1[1];
    var ref2 = (0,react.useState)(booking.travellers.filter(function(traveller) {
        return traveller.ageGroup.type === "MINOR";
    })), children = ref2[0], setChildren = ref2[1];
    var ref3 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(booking.babies)), babies = ref3[0], setBabies = ref3[1];
    var adultAgeGroup = manager.getAdultAgeGroup(ageGroupSettings.ageGroups);
    var handleClose = function() {
        setOpen(open === false ? null : false);
    };
    (0,react.useEffect)(function() {
        setInputValue(manager.getTravellerSelectionLabel(t));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        booking.travellers,
        booking.babies
    ]);
    var handleChangeTraveller = function(ageGroup, action) {
        var travellers = (0,_to_consumable_array/* default */.Z)(booking.travellers);
        // add/remove
        switch(action){
            case "increase":
                travellers.push({
                    ageGroup: ageGroup
                });
                break;
            case "decrease":
                var index = travellers.findIndex(function(traveller) {
                    return ageGroup.id === traveller.ageGroup.id;
                });
                travellers.splice(index, 1);
                break;
        }
        // travellers = orderTravellers(travellers, ageGroupSettings.ageGroups)
        dispatch((0,features_booking/* setTravellers */.HO)({
            travelId: booking.travelId,
            travellers: travellers
        }));
        setInputValue(manager.getTravellerSelectionLabel(t));
    };
    var childrenAgeRange = getChildrenAgeRange(ageGroupSettings.ageGroups);
    var handleChangeNumberOfChildren = function(action) {
        switch(action){
            case "increase":
                children.push({
                    birthday: ""
                });
                break;
            case "decrease":
                children.splice(-1, 1);
                break;
        }
        dispatchChildren(children);
        setChildren((0,_to_consumable_array/* default */.Z)(children));
    };
    var setChildBirthday = function(index, birthday) {
        var newChildren = children.map(function(child) {
            return (0,_object_spread/* default */.Z)({}, child);
        });
        newChildren[index].birthday = birthday ? (0,helpers/* toDbDate */.bQ)(birthday) : "";
        setChildren((0,_to_consumable_array/* default */.Z)(newChildren));
        if (!missingChildrenBirthdaysCount(newChildren)) {
            dispatchChildren(newChildren);
        }
    };
    var dispatchChildren = function(children) {
        dispatch((0,features_booking/* setChildren */.IX)({
            travelId: booking.travelId,
            children: children.map(function(child) {
                return {
                    birthday: child.birthday
                };
            })
        }));
    };
    var missingChildrenBirthdaysCount = function(children) {
        var missingCount = 0;
        children.forEach(function(child) {
            if (!child.birthday) {
                missingCount++;
            }
        });
        return missingCount;
    };
    var getChildBirthdayMinDate = function() {
        // get minors max age from ageGroups
        var maxAge = 0;
        ageGroupSettings.ageGroups.filter(function(ageGroup) {
            return ageGroup.type === "MINOR";
        }).forEach(function(ageGroup) {
            if (maxAge < ageGroup.maxAge) {
                maxAge = ageGroup.maxAge;
            }
        });
        // calculate minDate from travel end date + 1 day
        // @ts-ignore
        var date = new Date(booking.travelDate.endDate);
        date.setFullYear(date.getFullYear() - maxAge - 1);
        date.setDate(date.getDate() + 1);
        return date;
    };
    var getChildBirthdayMaxDate = function() {
        var ref;
        // get minors max age from ageGroups
        var minAge = 999;
        ageGroupSettings.ageGroups.filter(function(ageGroup) {
            return ageGroup.type === "MINOR";
        }).forEach(function(ageGroup) {
            if (minAge > ageGroup.minAge) {
                minAge = ageGroup.minAge;
            }
        });
        // calculate minDate from travel end date
        // @ts-ignore
        var date = new Date((ref = booking.travelDate) === null || ref === void 0 ? void 0 : ref.endDate);
        date.setFullYear(date.getFullYear() - minAge);
        date.setDate(date.getDate());
        return date;
    };
    var dispatchBabies = function(babies) {
        if (!missingBabiesBirthdaysCount(babies)) {
            dispatch((0,features_booking/* setBabies */.dk)({
                travelId: booking.travelId,
                babies: babies.map(function(baby) {
                    return {
                        birthday: baby.birthday
                    };
                })
            }));
        }
    };
    var handleChangeNumberOfBabies = function(action) {
        switch(action){
            case "increase":
                babies.push({
                    birthday: ""
                });
                break;
            case "decrease":
                babies.splice(-1, 1);
                break;
        }
        dispatchBabies(babies);
        setBabies((0,_to_consumable_array/* default */.Z)(babies));
    };
    var missingBabiesBirthdaysCount = function(babies) {
        var missingCount = 0;
        babies.forEach(function(baby) {
            if (!baby.birthday) {
                missingCount++;
            }
        });
        return missingCount;
    };
    var setBabyBirthday = function(index, birthday) {
        var newBabies = babies.map(function(child) {
            return (0,_object_spread/* default */.Z)({}, child);
        });
        newBabies[index].birthday = birthday ? (0,helpers/* toDbDate */.bQ)(birthday) : "";
        setBabies((0,_to_consumable_array/* default */.Z)(newBabies));
        dispatchBabies(newBabies);
    };
    var getBabyBirthdayMinDate = function() {
        var ref, ref1;
        // get minors max age from ageGroups
        var maxAge = Number((ref = booking.travel) === null || ref === void 0 ? void 0 : ref.pricing.ageGroupSettings.freeUntilAge);
        // calculate minDate from travel start date
        // @ts-ignore
        var date = new Date((ref1 = booking.travelDate) === null || ref1 === void 0 ? void 0 : ref1.endDate);
        date.setFullYear(date.getFullYear() - maxAge);
        date.setDate(date.getDate() + 1);
        return date;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectWidget_SelectWidget, {
            variant: colorTheme === "light" ? "default" : "whiteOutline",
            open: open,
            placeholder: t("booking.numberOfPeople"),
            inputValue: inputValue,
            preventCloseOnClickOutside: childrenAllowed || babiesAllowed,
            disabled: !booking.travelDate,
            renderWidget: function() {
                var ref;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TravellerSelector_module_default()).widget,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            fluid: true,
                            className: "px-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    className: "justify-content-between align-items-center ".concat((TravellerSelector_module_default()).ageGroup),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: "auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TravellerSelector_module_default()).label,
                                                    children: childrenAllowed || babiesAllowed ? t("booking.adults") : t("booking.persons")
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: "auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberToggle/* default */.Z, {
                                                value: booking.travellers.filter(function(traveller) {
                                                    return traveller.ageGroup.type === "ADULT";
                                                }).length,
                                                onChange: function(value, action) {
                                                    handleChangeTraveller(adultAgeGroup, action);
                                                }
                                            })
                                        })
                                    ]
                                }),
                                childrenAllowed && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                        className: "justify-content-between align-items-center ".concat((TravellerSelector_module_default()).ageGroup),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xs: "auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (TravellerSelector_module_default()).label,
                                                        children: [
                                                            t("booking.children"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: (TravellerSelector_module_default()).ageRange,
                                                                children: [
                                                                    "(",
                                                                    t("booking.ageRange", {
                                                                        minAge: childrenAgeRange.min,
                                                                        maxAge: childrenAgeRange.max
                                                                    }),
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xs: "auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberToggle/* default */.Z, {
                                                    value: children.length,
                                                    onChange: function(value, action) {
                                                        handleChangeNumberOfChildren(action);
                                                    }
                                                })
                                            }),
                                            (0,_to_consumable_array/* default */.Z)(Array(children.length)).map(function(element, index) {
                                                var maxBirthday = getChildBirthdayMaxDate();
                                                var minBirthday = getChildBirthdayMinDate();
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex align-items-center pt-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                            children: [
                                                                t("booking.child"),
                                                                " ",
                                                                index + 1
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                            xs: "auto",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BirthdayPicker_BirthdayPicker, {
                                                                width: "140px",
                                                                value: children[index].birthday ? new Date(children[index].birthday) : null,
                                                                onChange: function(newValue) {
                                                                    if (dateIsInInRange(newValue, minBirthday, maxBirthday)) {
                                                                        setChildBirthday(index, newValue);
                                                                    }
                                                                },
                                                                maxDate: maxBirthday,
                                                                minDate: minBirthday
                                                            })
                                                        })
                                                    ]
                                                }, index);
                                            }),
                                            !!missingChildrenBirthdaysCount(children) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TravellerSelector_module_default()).childError,
                                                children: t("booking.childrenBirthdayMissing", {
                                                    count: missingChildrenBirthdaysCount(children)
                                                })
                                            })
                                        ]
                                    })
                                }),
                                babiesAllowed && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                        className: "justify-content-between align-items-center ".concat((TravellerSelector_module_default()).ageGroup),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xs: "auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (TravellerSelector_module_default()).label,
                                                        children: [
                                                            t("booking.babies"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: (TravellerSelector_module_default()).ageRange,
                                                                children: [
                                                                    "(",
                                                                    t("booking.untilAge", {
                                                                        age: (ref = booking.travel) === null || ref === void 0 ? void 0 : ref.pricing.ageGroupSettings.freeUntilAge
                                                                    }),
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xs: "auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberToggle/* default */.Z, {
                                                    value: babies.length,
                                                    onChange: function(value, action) {
                                                        handleChangeNumberOfBabies(action);
                                                    }
                                                })
                                            }),
                                            (0,_to_consumable_array/* default */.Z)(Array(babies.length)).map(function(element, index) {
                                                var minBirthday = getBabyBirthdayMinDate();
                                                var maxBirthday = new Date();
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex align-items-center pt-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                            children: [
                                                                t("booking.baby"),
                                                                " ",
                                                                index + 1
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                            xs: "auto",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BirthdayPicker_BirthdayPicker, {
                                                                width: "140px",
                                                                value: babies[index].birthday ? new Date(babies[index].birthday) : null,
                                                                onChange: function(newValue) {
                                                                    if (dateIsInInRange(newValue, minBirthday, maxBirthday)) {
                                                                        setBabyBirthday(index, newValue);
                                                                    }
                                                                },
                                                                minDate: minBirthday
                                                            })
                                                        })
                                                    ]
                                                }, index);
                                            }),
                                            !!missingBabiesBirthdaysCount(babies) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TravellerSelector_module_default()).childError,
                                                children: t("booking.childrenBirthdayMissing", {
                                                    count: missingBabiesBirthdaysCount(babies)
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        className: "text-end pt-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "outline-dark",
                                            size: "sm",
                                            onClick: handleClose,
                                            disabled: !!missingChildrenBirthdaysCount(children) || !!missingBabiesBirthdaysCount(babies),
                                            children: t("booking.next")
                                        })
                                    })
                                })
                            ]
                        })
                    })
                });
            }
        })
    });
};
/* harmony default export */ var TravellerSelector_TravellerSelector = (TravellerSelector);

;// CONCATENATED MODULE: ./src/components/models/booking/InitBooking/TravellerSelector/index.ts


// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/models/booking/InitBooking/TransportTypeSelector/TransportTypeSelector.module.scss
var TransportTypeSelector_module = __webpack_require__(91315);
var TransportTypeSelector_module_default = /*#__PURE__*/__webpack_require__.n(TransportTypeSelector_module);
;// CONCATENATED MODULE: ./src/components/models/booking/InitBooking/TransportTypeSelector/TransportTypeSelector.tsx








var TransportTypeSelector = function(param) {
    var pricingTravels = param.pricingTravels, _colorTheme = param.colorTheme, colorTheme = _colorTheme === void 0 ? "light" : _colorTheme;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var travelId = (0,react.useContext)(context/* TravelIdContext */.Hu);
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var bookings = (0,hooks/* useAppSelector */.C)(features_booking/* selectBookings */.wY);
    var booking = (0,features_booking/* getStateBooking */.U_)(bookings, travelId);
    var ref = (0,react.useState)(pricingTravels.length === 1 ? pricingTravels[0] : undefined), activePricingTravel = ref[0], setActivePricingTravel = ref[1];
    (0,react.useEffect)(function() {
        if (activePricingTravel) {
            dispatch((0,features_booking/* setPricingTravelId */.Tr)({
                travelId: travelId,
                pricingTravelId: activePricingTravel.id
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activePricingTravel
    ]);
    var onChange = function(pricingTravel) {
        setActivePricingTravel(pricingTravel);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: booking && pricingTravels.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect_CustomSelect, {
            variant: colorTheme === "light" ? "default" : "whiteOutline",
            placeholder: t("booking.transportType"),
            options: pricingTravels,
            selected: booking.pricingTravel,
            onChange: onChange,
            renderOption: function(pricingTravel) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TransportTypeSelector_module_default()).option,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TransportTypeSelector_module_default()).date,
                        children: pricingTravel.transportTypeLabel
                    })
                });
            },
            renderInputValue: function(pricingTravel) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: pricingTravel.transportTypeLabel
                });
            }
        })
    });
};
/* harmony default export */ var TransportTypeSelector_TransportTypeSelector = (TransportTypeSelector);

;// CONCATENATED MODULE: ./src/components/models/booking/InitBooking/TransportTypeSelector/index.ts


// EXTERNAL MODULE: ./src/components/models/booking/NotBookableInfo/NotBookableInfo.module.scss
var NotBookableInfo_module = __webpack_require__(74962);
var NotBookableInfo_module_default = /*#__PURE__*/__webpack_require__.n(NotBookableInfo_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Alert.js
var Alert = __webpack_require__(88375);
// EXTERNAL MODULE: ./src/components/elements/media/ThemeImage/ThemeImage.tsx
var ThemeImage = __webpack_require__(38567);
;// CONCATENATED MODULE: ./src/components/models/booking/NotBookableInfo/NotBookableInfo.tsx






var NotBookableInfo = function(param) {
    var availabilityStatus = param.availabilityStatus, contactBlockSettings = param.contactBlockSettings;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var phonePrefix = contactBlockSettings.phonePrefix, phone = contactBlockSettings.phone, phone2Prefix = contactBlockSettings.phone2Prefix, phone2 = contactBlockSettings.phone2, openingHours1 = contactBlockSettings.openingHours1, openingHours2 = contactBlockSettings.openingHours2, email = contactBlockSettings.email;
    var phoneLink = !phone ? phone : "tel:" + phone.replace("(0)", "").split(" ").join("");
    var phone2Link = !phone2 ? phone2 : "tel:" + phone2.replace("(0)", "").split(" ").join("");
    if (!availabilityStatus || !availabilityStatus.tenantSettings || availabilityStatus.status !== "CLOSED") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var tenantSettings = availabilityStatus.tenantSettings.find(function(tenantSettings) {
        return tenantSettings.tenant.id === "1";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: (NotBookableInfo_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                        children: tenantSettings && tenantSettings.info ? tenantSettings.info : t("booking.notBookableMessage")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                className: (NotBookableInfo_module_default()).contactBlock,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        xs: "auto",
                        className: "".concat((NotBookableInfo_module_default()).icon, " align-content-center"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeImage/* default */.Z, {
                            src: "/images/mandatory/icons/contact/phone.png",
                            alt: "icon",
                            width: 40,
                            height: 40
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        className: "d-flex align-items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((NotBookableInfo_module_default()).link, " mb-1"),
                                    children: [
                                        phonePrefix && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                phonePrefix,
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: phoneLink,
                                            "data-tr-click": "not_bookable_info:contact_phone:click",
                                            children: phone
                                        })
                                    ]
                                }),
                                phone2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((NotBookableInfo_module_default()).link, " mb-1"),
                                    children: [
                                        phone2Prefix && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                phone2Prefix,
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: phone2Link,
                                            "data-tr-click": "not_bookable_info:contact_phone:click",
                                            children: phone2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (NotBookableInfo_module_default()).openingHours,
                                    children: [
                                        openingHours1,
                                        openingHours2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                openingHours2
                                            ]
                                        }) : ""
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                className: (NotBookableInfo_module_default()).contactBlock,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        xs: "auto",
                        className: (NotBookableInfo_module_default()).icon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeImage/* default */.Z, {
                            src: "/images/mandatory/icons/contact/mail.png",
                            alt: "icon",
                            width: 40,
                            height: 40
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        className: "d-flex align-items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (NotBookableInfo_module_default()).link,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "mailto:" + email,
                                "data-tr-click": "not_bookable_info:contact_email:click",
                                children: email
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var NotBookableInfo_NotBookableInfo = (NotBookableInfo);

;// CONCATENATED MODULE: ./src/components/models/booking/NotBookableInfo/index.ts


// EXTERNAL MODULE: ./src/components/models/booking/InitBooking/AvailabilityStatusInfo/AvailabilityStatusInfo.module.scss
var AvailabilityStatusInfo_module = __webpack_require__(29714);
var AvailabilityStatusInfo_module_default = /*#__PURE__*/__webpack_require__.n(AvailabilityStatusInfo_module);
;// CONCATENATED MODULE: ./src/components/models/booking/InitBooking/AvailabilityStatusInfo/AvailabilityStatusInfo.tsx



var AvailabilityStatusInfo = function(param) {
    var tenantSettings = param.availabilityStatusTenantSettings;
    if (!tenantSettings.info) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
        className: (AvailabilityStatusInfo_module_default()).infoAlert,
        variant: "warning",
        children: tenantSettings.info
    });
};
/* harmony default export */ var AvailabilityStatusInfo_AvailabilityStatusInfo = (AvailabilityStatusInfo);

;// CONCATENATED MODULE: ./src/components/models/booking/InitBooking/AvailabilityStatusInfo/index.ts


// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Placeholder.js + 2 modules
var Placeholder = __webpack_require__(14331);
;// CONCATENATED MODULE: ./src/components/models/booking/InitBooking/InitBookingLoadingPlaceholder/InitBookingLoadingPlaceholder.tsx



var InitBookingLoadingPlaceholder = function(param) {
    var navType = param.navType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((InitBooking_module_default()).root, " ").concat((InitBooking_module_default())[navType]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (InitBooking_module_default()).header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Placeholder/* default */.Z, {
                        as: "p",
                        animation: "glow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Placeholder/* default */.Z, {
                                xs: 7,
                                className: "mb-3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Placeholder/* default */.Z, {
                                xs: 12
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (InitBooking_module_default()).basePrice,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Placeholder/* default */.Z, {
                            as: "p",
                            animation: "glow",
                            className: "mb-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Placeholder/* default */.Z, {
                                xs: 12
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Placeholder/* default */.Z, {
                            as: "p",
                            animation: "glow",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Placeholder/* default */.Z, {
                                    xs: 12,
                                    className: "mb-3"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Placeholder/* default */.Z, {
                                    xs: 12,
                                    className: "mb-3"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var InitBookingLoadingPlaceholder_InitBookingLoadingPlaceholder = (InitBookingLoadingPlaceholder);

;// CONCATENATED MODULE: ./src/components/models/booking/InitBooking/InitBookingLoadingPlaceholder/index.ts


// EXTERNAL MODULE: ./src/components/elements/icons/ArrowIcon/index.ts + 1 modules
var ArrowIcon = __webpack_require__(66707);
;// CONCATENATED MODULE: ./src/components/models/booking/InitBooking/buttons/StartBookingButtonLead/StartBookingButtonLead.tsx




var StartBookingButtonLead = function(param) {
    var onClick = param.onClick, disabled = param.disabled;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
        onClick: onClick,
        variant: "signal",
        className: "w-100 an-wobble-horizontal-trigger fs-4",
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {
                fontsize: "5rem",
                className: "me-2"
            }),
            t("booking.next")
        ]
    });
};
/* harmony default export */ var StartBookingButtonLead_StartBookingButtonLead = (StartBookingButtonLead);

;// CONCATENATED MODULE: ./src/components/models/booking/InitBooking/buttons/StartBookingButtonLead/index.ts


;// CONCATENATED MODULE: ./src/components/models/booking/InitBooking/InitBooking.tsx





















var InitBooking = function(param) {
    var contactBlockSettings = param.contactBlockSettings, _colorTheme = param.colorTheme, colorTheme = _colorTheme === void 0 ? "light" : _colorTheme, setMobileOpen = param.setMobileOpen, _navType = param.navType, navType = _navType === void 0 ? "wizard" : _navType;
    var ref, ref1;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var travelId = (0,react.useContext)(context/* TravelIdContext */.Hu);
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var bookings = (0,hooks/* useAppSelector */.C)(features_booking/* selectBookings */.wY);
    var booking = (0,features_booking/* getStateBooking */.U_)(bookings, travelId);
    var manager = new LocalBooking/* default */.Z(booking);
    (0,react.useEffect)(function() {
        dispatch((0,features_booking/* initBooking */.ci)({
            travelId: travelId
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleStartBooking = function() {
        dispatch((0,features_booking/* setCurrentBookingStep */.VF)({
            travelId: travelId,
            step: 0
        }));
    };
    if (!booking || !booking.travel) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(InitBookingLoadingPlaceholder_InitBookingLoadingPlaceholder, {
            navType: navType
        });
    }
    if (manager.getAvailabilityStatus().status === "CLOSED") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((InitBooking_module_default()).root, " ").concat((InitBooking_module_default()).wrapSpacingTop, " px-0"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotBookableInfo_NotBookableInfo, {
                availabilityStatus: manager.getAvailabilityStatus(),
                contactBlockSettings: contactBlockSettings
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-a3236c6234300313",
                children: booking && booking.travel && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-a3236c6234300313" + " " + "".concat((InitBooking_module_default()).root, " ").concat((InitBooking_module_default())[navType]),
                    children: [
                        setMobileOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-a3236c6234300313" + " " + "".concat((InitBooking_module_default()).mobileNav, " d-lg-none"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "outline-light",
                                className: "text-uppercase",
                                onClick: function() {
                                    return setMobileOpen(false);
                                },
                                children: t("button.close")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-a3236c6234300313" + " " + ((InitBooking_module_default()).header || ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-a3236c6234300313" + " " + ((InitBooking_module_default()).lead || ""),
                                    children: t("booking.startPlanTravel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-a3236c6234300313" + " " + ((InitBooking_module_default()).title || ""),
                                    children: booking.travel.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailabilityStatusInfo_AvailabilityStatusInfo, {
                                    availabilityStatusTenantSettings: manager.getAvailabilityStatusTenantSettings()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            fluid: true,
                            className: "p-0 ".concat((InitBooking_module_default()).basePrice),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    className: "justify-content-between align-items-baseline mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: "auto",
                                            className: (InitBooking_module_default()).label,
                                            children: t("booking.pricePerPerson")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                            className: "text-end",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "jsx-a3236c6234300313" + " " + ((InitBooking_module_default()).from || ""),
                                                    children: [
                                                        t("booking.priceFrom"),
                                                        "\xa0"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "jsx-a3236c6234300313" + " " + ((InitBooking_module_default()).price || ""),
                                                    children: manager.formatPrice(booking.travel.minPrice)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransportTypeSelector_TransportTypeSelector, {
                                                pricingTravels: booking.travel.pricing.travels,
                                                colorTheme: colorTheme
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelDateSelector_TravelDateSelector, {
                                                colorTheme: colorTheme
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravellerSelector_TravellerSelector, {
                                                ageGroupSettings: booking.travel.pricing.ageGroupSettings,
                                                colorTheme: colorTheme
                                            })
                                        })
                                    ]
                                }),
                                navType === "lead" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    className: "mb-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/booking/".concat(booking.travel.seoSettings.urlSlug),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StartBookingButtonLead_StartBookingButtonLead, {
                                                onClick: handleStartBooking,
                                                disabled: booking.travelDate === undefined || !((ref = booking.travellers) === null || ref === void 0 ? void 0 : ref.length)
                                            })
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                        className: "justify-content-between mt-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xs: "auto"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xs: "auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    variant: "none",
                                                    className: "btn-booking-step-next",
                                                    onClick: handleStartBooking,
                                                    disabled: booking.travelDate === undefined || !((ref1 = booking.travellers) === null || ref1 === void 0 ? void 0 : ref1.length),
                                                    children: t("booking.next")
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "a3236c6234300313",
                children: "@media screen and (max-width:992px){.glob-cookie-banner{bottom:58px}}"
            })
        ]
    });
};
/* harmony default export */ var InitBooking_InitBooking = (InitBooking);

;// CONCATENATED MODULE: ./src/components/models/booking/InitBooking/index.ts



/***/ }),

/***/ 17906:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomSelect_root__B0EtX","input":"CustomSelect_input__htkGn","disabled":"CustomSelect_disabled__qih45","active":"CustomSelect_active__aRFEo","noOptions":"CustomSelect_noOptions__JCmow","option":"CustomSelect_option__B9Cf0","focus":"CustomSelect_focus__m3cDO","selected":"CustomSelect_selected__MKZlj","whiteOutline":"CustomSelect_whiteOutline__g6cKa","dropdown":"CustomSelect_dropdown__cWAuC"};

/***/ }),

/***/ 61430:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectWidget_root__Uqcxz","input":"SelectWidget_input__wBtP8","disabled":"SelectWidget_disabled__3ZrDc","active":"SelectWidget_active__zhR95","whiteOutline":"SelectWidget_whiteOutline__AltRH","dropdown":"SelectWidget_dropdown__yKPbJ"};

/***/ }),

/***/ 29714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"infoAlert":"AvailabilityStatusInfo_infoAlert__lfq5Z"};

/***/ }),

/***/ 52619:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapSpacingTop":"InitBooking_wrapSpacingTop__t32V6","root":"InitBooking_root__9oCXm","mobileNav":"InitBooking_mobileNav__d0Uec","header":"InitBooking_header__X1lKf","title":"InitBooking_title__fpwU0","lead":"InitBooking_lead__mR53_","basePrice":"InitBooking_basePrice__ofMG1","label":"InitBooking_label__ioba7","from":"InitBooking_from__pb9tF","price":"InitBooking_price__o3S28","accordion":"InitBooking_accordion___iQIj"};

/***/ }),

/***/ 91315:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"option":"TransportTypeSelector_option__uO68F","extension":"TransportTypeSelector_extension__eOCj8","label":"TransportTypeSelector_label__oDfjb"};

/***/ }),

/***/ 39202:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"option":"TravelDateSelector_option__k3Hkv","extension":"TravelDateSelector_extension__nZS0Q","label":"TravelDateSelector_label__rvjuv"};

/***/ }),

/***/ 93632:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"widget":"TravellerSelector_widget__SccG4","ageGroup":"TravellerSelector_ageGroup__VaNpX","label":"TravellerSelector_label__NhHq7","ageRange":"TravellerSelector_ageRange___Ng0F","childError":"TravellerSelector_childError__zbxVx"};

/***/ }),

/***/ 74962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"NotBookableInfo_root__0UuCN","contactBlock":"NotBookableInfo_contactBlock__LocnR","icon":"NotBookableInfo_icon__mty2b","link":"NotBookableInfo_link__3dRs_","openingHours":"NotBookableInfo_openingHours__Hg4Xl"};

/***/ })

}]);